import { Component, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { FlashService } from "../../flash/flash.service";
import { PersonalDetailsService } from "../../services/personal-details.service";
import { OffboardingService } from "../../services/offboarding.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

@Component({
  selector: "app-personal-details",
  templateUrl: "./personal-details.component.html",
  styleUrls: ["./personal-details.component.css"],
})
export class PersonalDetailsComponent implements OnInit {
  constructor(
    private service: PersonalDetailsService,
    private flashService: FlashService,
    private activatedRoute: ActivatedRoute,
    private offboardingService : OffboardingService,
    private spinnerService: Ng4LoadingSpinnerService,

  ) { }

  currentUser: any;
  status: string;
  isButtonDisabled: boolean = false;
  exp_ans = [];
  showform:boolean;

  public groups: any;
  public form: FormGroup;
  unsubcribe: any;
  inValid: boolean = false;
  public elementName = [];
  public formsStatus: Object = {};

  save(status: string) {
    this.status = status;
  }
  requestId: any;

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    this.spinnerService.show()
    this.groups = JSON.parse(localStorage.getItem("pd_form"));
    this.activatedRoute.params.subscribe((params) => {
      this.requestId = params["requestId"];
      this.spinnerService.hide()
    });

    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    // FB
    this.generateForm();
    this.getpd_answer()
    this.getOffboardingEmployeeDetails();
  }

  cc() {
    this.exp_ans = [];

    let keys_data = Object.keys(this.form.value);
    let value_data = Object.values(this.form.value);

    keys_data.forEach((element, index) => {
      var item = this.groups.find((item) => item.name === element);

      if ((typeof value_data[index] === "object") === true) {

        var obj = value_data[index];

        var keys = Object.keys(obj);

        var filtered = keys.filter(function (key) {
          return obj[key];
        });

        this.exp_ans.push({ name: item.name,id: item.id, ans: filtered });

      } else {
        this.exp_ans.push({ name: item.name,id: item.id, ans: value_data[index] });
      }

      if(value_data[index] === undefined){
        return this.inValid = true
     }
    });

    this.inValid = false;
    
    let obj = Object.values(this.form.value);

    obj.forEach((element) => {
      if (element === "") {
        this.inValid = true;
      }
    });

    this.elementName = [];

    this.exp_ans.forEach(ele => {
      if(!ele.ans){
        this.elementName.push(ele.name);
      }
    });

    if(this.elementName.length){
      this.inValid = true;
    }

    if(this.inValid === false) {
      this.onSubmit()};
  }

  generateForm() {
    this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.groups)),
    });

    this.form = new FormGroup({});

    this.groups.forEach((x) => {
      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));
        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );
        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });
  }

  getFields() {
    return this.groups;
  }

  onSubmit() {
    const payload = {
      emp_id: this.currentUser.id.toString(),
      data: this.exp_ans,
    };

    this.spinnerService.show();
    this.service.createPersonalDetails(payload).subscribe(
      (data) => {
        if (data.body["success"]) {
          this.flashService.show(data.body["message"], "alert-success");
          this.getpd_answer();
          
        } else {
          this.flashService.show(data.body["message"], "alert-success");
          this.getpd_answer();
          
        }
        this.spinnerService.hide();
        this.getOffboardingEmployeeDetails();
      },
      (err) => {
        this.spinnerService.hide();
        console.log("Create Personal Details Form Error:", err);
        this.flashService.show(err.error.message["message"], "alert-danger");
      }
    );
  }

  answers:any[] = [];
  tem:any;
  
  getpd_answer(){
    this.spinnerService.show();
    this.service.getAnswer(this.currentUser.id.toString()).subscribe(
      (data) => {
        this.tem = data.body;
        this.answers = this.tem.questions;
        const arr = this.answers
        if(arr.length > 0){
          this.showform = false
        }else{
          this.showform = true
        }
        this.spinnerService.hide();
      },
      (err) => {
        console.log("get Answer Error:", err);
      }
    );
  }

  getOffboardingEmployeeDetails(){
    this.spinnerService.show();
    this.offboardingService.getOffboardingEmployeeDetails(this.currentUser.id.toString()).subscribe(
      (data) => {

        this.formsStatus = data.body.data;
        this.spinnerService.hide();
      },
      (err) => {
        this.spinnerService.hide();
        console.log("Get Offboarding Employee Details Error:", err);
      }
    );
  }
  
}


// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/personal-details/personal-details.component.ts